/* eslint-disable */
import createIcon from '../createIcon';

const IconPlusOutlined = createIcon({
  name: 'icon-plus-outlined',
  content: '<path d="M830.287492 544.816428h-637.212196v-63.72122h637.212196z"/><path d="M544.179216 194.34972v637.212197h-63.72122v-637.212197z"/>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconPlusOutlined;
